import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgCalendar(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    stroke: "inherit",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    strokeLinecap: "round",
    d: "M6 18h1v-1H6zM10 18h1v-1h-1zM14 18h1v-1h-1zM6 14h1v-1H6zM10 14h1v-1h-1zM14 14h1v-1h-1zM18 14h1v-1h-1zM10 10h1V9h-1zM14 10h1V9h-1zM18 10h1V9h-1z"
  }), React.createElement("path", {
    d: "M23.5 1h-22v17.783A4.218 4.218 0 005.717 23h13.566a4.218 4.218 0 004.217-4.217V1zM5.5 4.174h14"
  })));
}
const MemoSvgCalendar = React.memo(SvgCalendar);
export default MemoSvgCalendar;